// extracted by mini-css-extract-plugin
export var standaloneTable = "_ic-0";
export var standaloneTableWithBodyFill = "_ic-1";
export var withExtraHeader = "_ic-2";